import { IState } from 'shared/store';

export const selectIsMyHomeObjectsExists = (state: IState) => {
  return state.valuationTraps.isMyHomeObjectsExists;
};
